module.exports = __webpack_public_path__ + "media/images/tunnel/paul-8972f25281e6dc4c42d0610739ef90ab.jpg";